import Vue from 'vue'

export interface SeoMetadata {
  title: string;
  description: string;
  robots?: string;
}

declare module 'vue/types/options' {
  interface ComponentOptions<V extends Vue> {
    seo?: SeoMetadata | ((vm: V) => SeoMetadata);
  }
}

export const siteUrl = 'https://aaroncunliffe.dev'
export const defaultDescription = 'Aaron Cunliffe, Principal Engineer in fintech and payments, focused on building reliable backend platforms, cloud infrastructure, integrations, and merchant-facing tools'

function updateMetaTag (name: string, content: string): void {
  let element = document.querySelector(`meta[name="${name}"]`)

  if (!element) {
    element = document.createElement('meta')
    element.setAttribute('name', name)
    document.head.appendChild(element)
  }

  element.setAttribute('content', content)
}

function updateCanonicalUrl (href: string): void {
  let element = document.querySelector('link[rel="canonical"]')

  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', 'canonical')
    document.head.appendChild(element)
  }

  element.setAttribute('href', href)
}

function updatePageSeo (seo: SeoMetadata, path: string): void {
  document.title = seo.title
  updateMetaTag('description', seo.description)
  updateMetaTag('robots', seo.robots || 'index,follow')
  updateCanonicalUrl(`${siteUrl}${path === '/' ? '/' : path}`)
}

export const seoMixin = Vue.extend({
  mounted (): void {
    const seo = this.$options.seo

    if (seo) {
      updatePageSeo(typeof seo === 'function' ? seo(this) : seo, this.$route.path)
    }
  }
})
